import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Title } from "@/components/UI";
import { ExpandableText } from "@/components/utilsComponents";
import { Box } from "@gemini/core";
export const Description = ({ testId, headline, text, title, }) => {
    const DESCRIPTION_MAX_LINES = 10;
    return (_jsxs(Box, { children: [(headline || title) && (_jsx(Title, { title: headline !== null && headline !== void 0 ? headline : title, testId: `${testId}.Title`, variant: "section", hasMargin: !!(text === null || text === void 0 ? void 0 : text.length), id: "description" })), !!(text === null || text === void 0 ? void 0 : text.length) && (_jsx(ExpandableText, { text: text, nbLines: DESCRIPTION_MAX_LINES, testId: `${testId}.Expandable-text`, withGradient: true }))] }));
};
